import { getInitialStateFromConfig } from "helpers/form";

const config = {
    averageFuelConsumption: {
        // field
        label: "Средний расход топлива",
        inputProps: { name: "averageFuelConsumption", type: "number", min: 0 },
    },
    averageFuelCostPerLiter: {
        // field
        label: "Средняя стоимость литра",
        inputProps: { name: "averageFuelCostPerLiter", type: "number", min: 0 },
    },
    costOfOneDay: {
        // field
        label: "Стоимость 1 дня работы",
        inputProps: { name: "costOfOneDay", type: "number", min: 0 },
    },
    hoursToDaysConvertasionsRate: {
        // field
        label: "Коэффициент преобразования часов в дни",
        inputProps: { name: "hoursToDaysConvertasionsRate", type: "number", min: 0 },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
